module.exports = __webpack_public_path__ + "img/icon-en.1c7070e8.png";